import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ConfigService } from '../shared/templates/Locale/locales.service';

@Component({
  selector: 'app-error-customer',
  templateUrl: './error-customer.component.html'
})
export class ErrorCustomerComponent implements OnInit {
  private ngUnsubscribe$: Subject<boolean> = new Subject();
  lang = "";
  action = "";
  errorRef="";
  constructor(private router : Router, private route: ActivatedRoute, private configService: ConfigService) { }

  ngOnInit() {
    this.route.params
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(params => {
        this.action = params['action'];
        this.lang = params['lang'];
        this.errorRef = params['error'];
      });
      this.configService.languagerequested = this.lang;
  }
  OnNavigateBack(): void{
    this.router.navigateByUrl(`customer/${this.action}/${this.lang}`);
  }
  ngOnDestroy() {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
